
import React from "react";
import ReactDOM from "react-dom";


import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "react-datepicker/dist/react-datepicker.css";
import "assets/css/default.css";
import "assets/css/loading.css";

import App from './App';

ReactDOM.render(
  <App/>,
  document.getElementById("root")
);
